import api from './api';

// İş mimarisi (kademeler, iş aileleri, ünvanlar, ücret bantları) tek çok sayfalı Excel ile yüklenir.
// execute, validate ile AYNI dosyayı yeniden gönderir: sunucu geçici dosya saklamaz (çok pod).
export const getJobArchitectureTemplate = () =>
  api.get('/v1/job-architecture-import/template', { responseType: 'blob' });

const upload = (path, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(path, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const validateJobArchitectureImport = (file) => upload('/v1/job-architecture-import/validate', file);

export const executeJobArchitectureImport = (file) => upload('/v1/job-architecture-import/execute', file);
